import { render, staticRenderFns } from "./HighlightsFormPage.vue?vue&type=template&id=338ffefe&"
import script from "./HighlightsFormPage.vue?vue&type=script&lang=js&"
export * from "./HighlightsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports